<template>
  <b-form method="POST" @submit.prevent="() => false">
    <b-row>

      <!-- Image -->
      <b-col>
        <b-tabs content-class="mt-3" justified>
          <b-tab :title="$t('content-fetch.labels.upload-image')" active>
            <asset-block :field="{ type: 'IMAGE' }" v-model="form.image" @input="submitInput" :state="null" />
            <p>{{ $t('content-fetch.hints.image-resize') }}</p>
          </b-tab>
          <b-tab :title="$t('content-fetch.labels.edit-image-url')">
            <b-input-group class="mt-3">
              <b-form-input v-model="form.imageURL" placeholder="https://imagesource/image.jpg" @input="submitInput"/>
            </b-input-group>
            <p class="mt-3">{{ $t('content-fetch.hints.image-display') }}</p>
          </b-tab>
        </b-tabs>
      </b-col>

    </b-row>
    <hr/>
    <b-row>
      <b-col>

        <!-- Description -->
        <b-form-group :label="$t('content-fetch.labels.description')" label-for="description">
          <b-form-text class="p-0 mb-2">{{ $t('content-fetch.hints.description-visibility') }}</b-form-text>
          <b-form-textarea id="description" v-model="form.description" :placeholder="$t('content-fetch.placeholders.description-content')" :rows="4" :max-rows="6" @input="submitInput" />
        </b-form-group>

      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import enumsMixin from '@/mixins/enums';
import formValidationMixin from '@src/mixins/formValidation';
import AssetBlock from '@/components/settings/AssetBlock';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AssetBlock,
  },
  mixins: [
    enumsMixin,
    formValidationMixin,
  ],
  data: () => ({
    form: {},
  }),
  created() {
    this.onResetForm();
  },
  formValidation: {
    title(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else if (value === '') {
        return 'EMPTY';
      } else {
        return true;
      }
    },
  },
  computed: {
    changed() {
      let value = {};
      if (this.value) {
        const { title, description, image } = this.value;
        value = { title, description, image };
      }
      return JSON.stringify(value) !== JSON.stringify(this.form);
    },
    isFormValid() {
      const invalidInputs = Object.keys(this.formValid).filter(key => this.formValid[key] !== true);
      if (invalidInputs.length) return false;
      return true;
    },
  },
  methods: {
    onResetForm() {
      if (this.value) {
        const { title, description, image, content, imageURL, url } = this.value;
        this.form = {
          title: title || null,
          description: description || null,
          content: content || null,
          image: image || null,
          imageURL: imageURL || null,
          url: url || null
        };
      }
    },
    submitInput() {
      if (!this.changed || !this.isFormValid) return;

      const input = JSON.parse(JSON.stringify(this.form));

      console.log('INPUT: ', input);

      if (input.description === '') input.description = null;
      this.$emit('input', input);
    },
  },
  watch: {
    value() {
      this.onResetForm();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/ContentHighlightEditorForm.vue